import { useMutation } from '@tanstack/react-query';
import { NotificationMessage } from '../../../../../../components';
import * as service from '../services';
import { CreateCustomSegmentDTO } from '../types';
import { useSetupISACustomSegmentsStore } from '../SetupISACustomSegments.store';
import { useGetCustomSegmentTableList } from './useGetCustomSegmentTableList';

interface EditSegmentParams {
  id: number;
  payload: CreateCustomSegmentDTO;
}

export const useEditCustomSegment = (setValue: (key: string, value: any) => void) => {
  const { setCreateEditSegmentCloseModal } = useSetupISACustomSegmentsStore();
  const { handleChangeCustomSegmentPage } = useGetCustomSegmentTableList();

  const updateSegment = async ({ id, payload }: EditSegmentParams) => {
    if (id === null) {
      console.error('ID não informado: updateSegment');
    }
    await service.updateCustomSegment(id, payload);
  };

  const successAction = () => {
    setCreateEditSegmentCloseModal();
    handleChangeCustomSegmentPage(1);
    setValue('segment_name', '');
    setValue('items', []);
    NotificationMessage('success', 5000, 'Segmento salvo com sucesso');
  };

  const errorAction = () => {
    setCreateEditSegmentCloseModal();
    NotificationMessage('error', 5000, 'Erro ao salvar segmento');
  };

  const mutation = useMutation({
    mutationFn: updateSegment,
    onSuccess: successAction,
    onError: errorAction,
  });

  return {
    handleEditSegmentMutation: mutation.mutate,
    isEditLoading: mutation.isPending,
  };
};
